import React, { useContext, useEffect, useState } from 'react';
import LocationInterface from '@solvhealth/types/interfaces/Location';
import Slot from '@solvhealth/types/interfaces/Location/Slot';
import { useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import withAuthentication from '../../../../../../../core/login/withAuthentication';
import { isPaymentCollectionDuringBookingEnabled } from '~/core/util/location';
import { bookingTimeSelected, setLocationId } from '~/actions/newBooking';
import history from '~/core/history';
import { getBookingFlowEntryRoute } from '../../../../../../../../src/routes/book/components/BookingFlow/util';
import { BOOKING_FORM_NON_PARTNER_CDP } from '~/core/util/bookingFlowRouting';
import { useLDFlags } from '~/core/launch-darkly/hooks/useLDFlags';
import { setCurrentlySelectedLocation } from '~/ducks/currentlySelectedLocation';
import MobileNearbyContainer from '~/components/ClinicDetailPageFlexible/components/BookModule/components/variants/NearbyBook/MobileNearbyContainer';
import DesktopNearbyContainer from '~/components/ClinicDetailPageFlexible/components/BookModule/components/variants/NearbyBook/DesktopNearbyContainer';
import { LocationContext } from '~/components/ClinicDetailPageFlexible/ContextProviders';
import { analyticsTrackEvent } from '~/core/analytics';
import { CDP_NEARBY_PARTNER_MODULE_LOADED } from '~/core/analytics/events';
import {
  getAllPartnerCount,
  getPartnerGroupIdList,
  getPartnerLocationIdList,
  N0_NEARBY_MODULE,
  NEARBY_MODULE_DESKTOP,
  NEARBY_MODULE_TIMED_POPUP,
} from '~/components/ClinicDetailPageFlexible/components/BookModule/components/variants/NearbyBook/trackingUtils';

type Props = {
  isMobileView?: boolean;
};

const NearbyBookModule = (props: Props) => {
  const { isMobileView } = props;
  const dispatch = useDispatch();
  const flags = useLDFlags();
  const { location, nearbyLocations } = useContext(LocationContext);
  const [viewableSlots, setViewableSlots] = useState({ today: 0, tomorrow: 0, cardCount: 0 });

  const getNearbyVariation = () => {
    if (isMobileView) {
      if (!isEmpty(nearbyLocations?.connect)) {
        return NEARBY_MODULE_TIMED_POPUP;
      }
      return N0_NEARBY_MODULE;
    }
    return NEARBY_MODULE_DESKTOP;
  };

  const nearbyVariation = getNearbyVariation();

  useEffect(() => {
    if (viewableSlots.cardCount === nearbyLocations?.connect?.length) {
      const partnerLocationIdList = getPartnerLocationIdList(nearbyLocations);
      const partnerGroupIdList = getPartnerGroupIdList(nearbyLocations);
      const partnerCount = getAllPartnerCount(nearbyLocations);

      analyticsTrackEvent(CDP_NEARBY_PARTNER_MODULE_LOADED, {
        referring_group_id_hash: location.groups[0].group_id,
        referring_location_id_hash: location.id,
        version: nearbyVariation,
        partner_location_list: partnerLocationIdList,
        partner_group_list: partnerGroupIdList,
        num_connect_partners: partnerCount.connect,
        num_boost_partners: partnerCount.boost,
        num_telemed_connect: partnerCount.telemed,
        pausedPartner: partnerCount.pausedPartner,
        num_same_day_timeslots: viewableSlots.today,
        num_next_day_timeslots: viewableSlots.tomorrow,
      });
    }
  }, [viewableSlots]);

  const handleRequestAppointment = (location: LocationInterface, slot: Slot) => {
    const shouldUseNewBookingFlow = flags.kis511H22022BookingFlow;

    dispatch(setLocationId(location.id));
    dispatch(setCurrentlySelectedLocation(location));
    dispatch(bookingTimeSelected(slot.appointmentDate));

    const url = getBookingFlowEntryRoute(
      shouldUseNewBookingFlow,
      BOOKING_FORM_NON_PARTNER_CDP,
      isPaymentCollectionDuringBookingEnabled(location),
      location.urlSlug
    );

    history.push(url);
  };

  if (isMobileView) {
    return (
      <MobileNearbyContainer
        handleRequestAppointment={handleRequestAppointment}
        isMobileView={isMobileView}
        nearbyLocations={nearbyLocations}
        nearbyVariation={nearbyVariation}
        referringLocation={location}
        setViewableSlots={setViewableSlots}
      />
    );
  }
  return (
    <DesktopNearbyContainer
      handleRequestAppointment={handleRequestAppointment}
      nearbyLocations={nearbyLocations}
      nearbyVariation={nearbyVariation}
      referringLocation={location}
      setViewableSlots={setViewableSlots}
    />
  );
};

export default withAuthentication(NearbyBookModule);
